/* eslint-disable */

export default {
  email: /.+@.+\.\w+/,
  youtube: /youtu\.be\/(.*)$/,
  wistia: /frame\.wistia\.com\/medias\/(\w*)$/,
};
